module.exports = __webpack_public_path__ + "img/pen-line-white.288418e2.svg";